interface Params {
  deliveryType: string;
  deliveryExpectation: string;
  customerPlacement?: string;
}

interface Pattern {
  pattern: RegExp;
  replacement: string;
  shortReplacement?: string;
}

interface DeliveryExpectation {
  deliveryExpectation: string;
  shortDeliveryExpectation: string;
}

const patterns: Record<string, Array<Pattern>> = {
  onDemand: [
    {
      pattern: /Delivery under an hour/gi,
      replacement: 'Arrives in 60 mins',
      shortReplacement: '60 mins',
    },
    {
      pattern: /Delivery in (\d+(?:\.\d+)?-\d+(?:\.\d+)?) minutes/gi,
      replacement: 'Arrives in $1 min',
      shortReplacement: '$1 min',
    },
    {
      pattern: /Delivery in (\d+(?:\.\d+)?-\d+(?:\.\d+)?) hours/gi,
      replacement: 'Arrives in $1 hrs',
      shortReplacement: '$1 hrs',
    },
  ],
  shipped: [
    {
      pattern: /Shipment \(?(\d+(?:-\d+)?)\s?(?:business )?(days)\)?/gi,
      replacement: 'Ships in $1 $2',
    },
    {
      pattern: /Usually ships within (\d+-\d+) business days/gi,
      replacement: 'Ships in $1 days',
    },
  ],
};

export function mapDeliveryExpectation({
  deliveryType,
  deliveryExpectation,
  customerPlacement,
}: Params): DeliveryExpectation {
  if (deliveryType === 'engraved') {
    const label = 'Ships in 10 days';
    return { shortDeliveryExpectation: label, deliveryExpectation: label };
  }
  if (['backOrder', 'back_order'].includes(customerPlacement)) {
    const label = 'On backorder';
    return { shortDeliveryExpectation: label, deliveryExpectation: label };
  }

  return (patterns[deliveryType] || []).reduce(
    (acc, { pattern, replacement, shortReplacement }) => {
      acc.deliveryExpectation = acc.deliveryExpectation.replace(pattern, replacement);
      acc.shortDeliveryExpectation = shortReplacement
        ? acc.shortDeliveryExpectation.replace(pattern, shortReplacement)
        : acc.deliveryExpectation;
      return acc;
    },
    { deliveryExpectation, shortDeliveryExpectation: deliveryExpectation },
  );
}
